<template>
  <div>
    <v-card v-if="requirement.userFeedback" outlined class="mt-12">
      <v-card-title>{{ $t("userFeedback.title") }}</v-card-title>

      <v-card-text>
        <Markdown :value="requirement.userFeedback" />
      </v-card-text>
    </v-card>

    <v-card v-if="requirement.auditorFeedback" outlined class="mt-4">
      <v-card-title>{{ $t("auditorFeedback.title") }}</v-card-title>

      <v-card-text>
        <Markdown :value="requirement.auditorFeedback" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    requirement: {
      type: Object,
      required: true,
    },
  },
};
</script>
